import { clamp, cloneDeep, isNumber, isUndefined } from 'lodash';
import type { IBrushDrawConfig } from '@/version-types';

/**
 * 等比缩放画笔配置。
 *
 * @param config - 画笔配置
 * @param currentWidth - 可选；当前宽度
 * @param ratio - 可选；显式缩放比例
 */
export function scaleConfig(config: IBrushDrawConfig, currentWidth?: number, ratio?: number) {
    const drawConfig = cloneDeep(config);
    const maxWidth = 100;
    if (isNumber(currentWidth) || isNumber(ratio)) {
        let r = ratio || 1;
        if (isUndefined(ratio) && isNumber(currentWidth)) {
            r = currentWidth / 1242;
        }
        drawConfig.fills.forEach((item, index) => {
            const width = clamp(Math.ceil(item.width * r), maxWidth);
            item.width = width;
            if (index) {
                item.offsetX = Math.ceil(((item.offsetX / Math.abs(item.offsetX)) * width) / 3);
                item.offsetY = Math.ceil(((item.offsetY / Math.abs(item.offsetY)) * width) / 3);
            }
        });
        if (drawConfig.stroke?.width) {
            drawConfig.stroke.width = clamp(Math.ceil(drawConfig.stroke.width * r), maxWidth);
        }
    }
    return drawConfig;
}
